const content = [
  {
    review:
      "Interessa, encanta e atrai a participação dos alunos, além de dar suporte para qualquer área da educação. Proporciona algo que considero muito significativo: melhora o letramento tecnológico e viabiliza o desenvolvimento de ações importantes para uma aprendizagem mais qualificada. Também aumenta o encantamento dos alunos em ir para a escola e melhora a frequência, o que é extremamente importante.",
    name: "Anaci Paim",
    status: "Secretária de Educação",
    image: "//donna.sistemadulino.com.br/site/recommendation/anaci-paim.jpg",
  },
  {
    review:
      "O Laboratório 7.0 Dulino vem para agregar metodologias ativas ao currículo, utilizando a tecnologia para proporcionar mais dignidade aos nossos alunos. Temos o desejo de ampliar nosso trabalho com aulas mais interessantes e voltadas para o futuro.",
    name: "Gleice",
    status: "Secretária de Educação",
    image: "//donna.sistemadulino.com.br/site/recommendation/gleice.jpg",
  },
  {
    review:
      "Eu me sinto muito feliz em saber que meus filhos estão tendo a oportunidade de estudar com a Dulino, de poder desenvolver suas habilidades e de conhecer esse mundo da tecnologia.",
    name: "Mãe de Aluno",
    status: "",
    image: "//donna.sistemadulino.com.br/site/recommendation/mae-de-aluno.jpg",
  },
  {
    review:
      "Antes da Dulino, procuramos bastante no mercado uma empresa que trabalhasse com robótica. No entanto, essa empresa precisaria ter um olhar além da tecnologia, mas também um olhar pedagógico, e que se encaixasse com a filosofia educacional da escola. Foi aí que encontramos a Dulino. Podemos afirmar que os orientadores que estiveram com nossos estudantes são de excelência. As famílias ficaram satisfeitíssimas porque perceberam os avanços pedagógicos na trajetória escolar dos filhos. A gente acredita que a robótica vai além do aprendizado de técnicas. A proposta precisa preparar para a vida, assim como o nosso colégio faz. Foi uma ótima escolha.",
    name: "Roberta Assis",
    status: "Diretora do Colégio Santa Catarina",
    image: "//donna.sistemadulino.com.br/site/recommendation/roberta-assis.jpg",
  },
];

export default content;
